import template from './product-check-table.template.html';
import controller from './product-check-table.controller';
import './product-check-table.scss';

export default {
  template,
  controller,
  bindings: {
    type: '<',
    stores: '<',
    stockList: '<?',
    priceList: '<?',
    ecommerceStockList: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check-table/product-check-table.component.js